import React from 'react';
import styles from './index.module.scss';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import rightArrow from '../../../../assets/global/right.svg';
import cross from '../../../../assets/global/cross.svg';
import filter from '../../../../assets/global/filter.svg';
import ACTION_TYPES from '../../../../store/actionTypes.constants';
import { useNavigate } from 'react-router-dom';
import {
  isObjectEmpty,
  formatAppliedFilters,
} from '../../../../utils/common.utils';
import { getUrlFilters, useParsedUrlFilters } from '../../offers.utils';
import { ctLogV2 } from '../../../../utils/cleverTapLogger.utils';
import { get } from 'lodash';
import { useIdHash, useNavigateRoute } from '../../../../hooks/custom.hooks';

function CategoryFilters({ data }) {
  const allFilters = get(data, 'filters', {});
  const navigateRoute = useNavigateRoute();

  const categories =
    useSelector(({ appReducer }) => appReducer.categories, shallowEqual) || [];

  const appliedFilters =
    useSelector(({ appReducer }) => appReducer.appliedFilters, shallowEqual) ||
    {};
  const appliedCategories = appliedFilters.category || [];
  const appliedSubCategories = appliedFilters.brand || [];

  const brands = allFilters?.brand;
  const prefBrands = get(brands, 'preferred_brands', []);
  const allOtherBrands = get(brands, 'all_other_brands', []);
  const allBrands = [...prefBrands, ...allOtherBrands];

  const dispatch = useDispatch();

  let filteredBrands = [];
  if (appliedCategories.length > 0) {
    filteredBrands = allBrands.filter(
      (entry) => appliedCategories.includes(entry.primary_category_id),
      // entry.primary_category_id === appliedCategories[0],
    );
  }
  // else {
  //   filteredBrands = [];
  // }

  const parsedFilters = useParsedUrlFilters();
  const { custId: cid, hash, isApp } = useIdHash();

  const applyFilter = (categoryId) => {
    let filters = [...appliedCategories];
    // let removeSubfilters = false;
    let urlFilters = getUrlFilters(appliedFilters);
    if (appliedCategories?.includes(categoryId)) {
      localStorage.setItem('filterTypeText', '');
      filters = filters?.filter((entry) => entry !== categoryId);
      // removeSubfilters = true;
      const updated = parsedFilters.category?.filter(
        (entry) => entry !== categoryId,
      );
      parsedFilters.category = updated;
    } else {
      localStorage.setItem('filterTypeText', 'quick_filter');
      filters.push(categoryId);
      parsedFilters.category = filters;
    }
    // if (filters.length > 1) {
    //   parsedFilters.brand = [];
    // }
    urlFilters = getUrlFilters(parsedFilters);

    dispatch({
      type: ACTION_TYPES.APPLIED_FILTERS,
      payload: {
        ...appliedFilters,
        category: filters,
        // brand: filters.length > 1 ? [] : appliedSubCategories,
      },
    });
    navigateRoute({
      nextPage: `/offers/?${urlFilters}`,
    });
    document.getElementById('categories').scrollTo({
      left: 0,
      behavior: 'smooth',
    });
  };

  const applySubFilter = (categoryId) => {
    let filters = [...appliedSubCategories];
    let urlFilters = getUrlFilters(appliedFilters);
    if (appliedSubCategories?.includes(categoryId)) {
      localStorage.setItem('filterTypeText', '');
      filters = filters.filter((entry) => entry !== categoryId);
      const updated = parsedFilters.brand?.filter(
        (entry) => entry !== categoryId,
      );
      parsedFilters.brand = updated;
    } else {
      localStorage.setItem('filterTypeText', 'quick_filter');
      filters.push(categoryId);
      parsedFilters.brand = filters;
    }
    urlFilters = getUrlFilters(parsedFilters);
    navigateRoute({
      nextPage: `/offers/?${urlFilters}`,
    });
    dispatch({
      type: ACTION_TYPES.APPLIED_FILTERS,
      payload: {
        ...appliedFilters,
        brand: filters,
      },
    });
  };
  const displayCategories = [
    ...categories.filter((entry) =>
      appliedFilters?.category?.includes(entry.id),
    ),
    ...categories.filter(
      (entry) => !appliedFilters?.category?.includes(entry.id),
    ),
  ];

  const navigate = useNavigate();

  const getAppliedFiltersCounts = () => {
    let count = 0;
    Object.keys(appliedFilters).map((entry) => {
      if (Array.isArray(appliedFilters[entry])) {
        if (appliedFilters[entry].length) {
          count += appliedFilters[entry].length;
        }
      } else {
        if (!isObjectEmpty(appliedFilters[entry])) {
          count++;
        }
      }
      if (entry === 'platform' && appliedFilters[entry] === 'all') {
        count--;
      }
      if (
        entry === 'offer_value' &&
        appliedFilters[entry]?.length &&
        appliedFilters[entry][0] === '0'
      )
        count--;
      return count;
    });
    return count;
  };

  const appliedCount = getAppliedFiltersCounts();

  return (
    <>
      <div className={styles.filterWrapper}>
        <div
          className={styles.filterBtn}
          onClick={() => {
            const urlFilters = getUrlFilters(parsedFilters);
            ctLogV2({
              eventName: 'Web_Filter_clicked',
              eventCategory: 'Offer Listing Page',
              eventDescription: 'Offer Listing Page - Web Filter Clicked',
              customerId: cid,
              extraData: {
                platform: isApp ? 'app' : 'web',
                filters_pre_applied:
                  formatAppliedFilters(appliedFilters, allFilters) || '',
              },
            });
            navigate(
              `/filters?${urlFilters}&cid=${cid}&customer-hash=${hash}&app=${isApp}`,
            );
          }}
        >
          {!isObjectEmpty(appliedFilters) && appliedCount > 0 ? (
            <span className={styles.number}>{appliedCount}</span>
          ) : (
            <img src={filter} alt="filters" className={styles.filterIcon} />
          )}
          Filters <img src={rightArrow} alt=">" className={styles.arrow} />
        </div>
        <div className={styles.categories} id="categories">
          {displayCategories.map((entry) => {
            const isApplied = appliedFilters?.category?.includes(entry.id);
            return (
              <div
                className={styles.categoryTab}
                key={entry.name}
                style={{
                  border: isApplied
                    ? '1px solid #FFA586'
                    : '1px solid transparent',
                }}
                onClick={() => applyFilter(entry.id)}
              >
                {entry.name}
                {isApplied ? (
                  <img src={cross} alt="x" className={styles.remove} />
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
      {filteredBrands.length ? (
        <div
          className={styles.filterWrapper}
          style={{
            paddingTop: 0,
          }}
        >
          <div className={styles.categories}>
            {filteredBrands.map((entry) => {
              const isApplied = appliedSubCategories?.includes(
                entry.merchant_id,
              );
              return (
                <div
                  className={styles.categoryTab}
                  key={entry.merchant_name}
                  style={{
                    border: isApplied
                      ? '1px solid #FFA586'
                      : '1px solid transparent',
                  }}
                  onClick={() => applySubFilter(entry.merchant_id)}
                >
                  {entry.merchant_name}
                  {isApplied ? (
                    <img src={cross} alt="x" className={styles.remove} />
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>
      ) : null}
    </>
  );
}

export default React.memo(CategoryFilters);
